export default __webpack_public_path__ + "static/media/plain-sticker-A.2af7b19a.png";